export default [
  {
    id: 1,
    imgUrl: 'assets/imgs/offer1.png',
    title: 'Reedem your points with 10% discount shopwide',
    subtitle: 'Save 0,15 per Litre at Caltex',
    description:
      "Cafe quality coffee in a compact footprint. The Bambino Plus doesn't compromise on the 4 key elements of cafe quality coffee. Delivering barista-quality performance using a 54mm portafilter with 19 grams for full flavour and an automatic steam wand for milk texturing. With a 3 second heat up time and precise espresso extraction, you can go from bean to cup, faster than ever before. Just like your local cafe.",
    point_1: 2000,
    point_2: 112000,
    brandImageUrl: 'assets/imgs/quantas_reward.png',
    price: 634,
    url: '',
  },
  {
    id: 2,
    imgUrl: 'assets/imgs/offer2.png',
    title: 'Save 0,15 per Litre at Caltex',
    subtitle: 'Save 0,15 per Litre at Caltex',
    description:
      "Cafe quality coffee in a compact footprint. The Bambino Plus doesn't compromise on the 4 key elements of cafe quality coffee. Delivering barista-quality performance using a 54mm portafilter with 19 grams for full flavour and an automatic steam wand for milk texturing. With a 3 second heat up time and precise espresso extraction, you can go from bean to cup, faster than ever before. Just like your local cafe.",
    point_1: 2000,
    point_2: 112000,
    brandImageUrl: 'assets/imgs/quantas_reward.png',
    price: 634,
    url: '',
  },
  {
    id: 3,
    imgUrl: 'assets/imgs/offer3.png',
    title: 'Save 0,15 per Litre at Caltex',
    subtitle: 'Save 0,15 per Litre at Caltex',
    description:
      "Cafe quality coffee in a compact footprint. The Bambino Plus doesn't compromise on the 4 key elements of cafe quality coffee. Delivering barista-quality performance using a 54mm portafilter with 19 grams for full flavour and an automatic steam wand for milk texturing. With a 3 second heat up time and precise espresso extraction, you can go from bean to cup, faster than ever before. Just like your local cafe.",
    point_1: 2000,
    point_2: 112000,
    brandImageUrl: 'assets/imgs/quantas_reward.png',
    price: 634,
    url: '',
  },
  {
    id: 4,
    imgUrl: 'assets/imgs/offer4.png',
    title: 'Breville Bambino Coffee Machine',
    subtitle: 'Save 0,15 per Litre at Caltex',
    description:
      "Cafe quality coffee in a compact footprint. The Bambino Plus doesn't compromise on the 4 key elements of cafe quality coffee. Delivering barista-quality performance using a 54mm portafilter with 19 grams for full flavour and an automatic steam wand for milk texturing. With a 3 second heat up time and precise espresso extraction, you can go from bean to cup, faster than ever before. Just like your local cafe.",
    point_1: 2000,
    point_2: 112000,
    brandImageUrl: 'assets/imgs/quantas_reward.png',
    price: 634,
    url: '',
  },
  {
    id: 5,
    imgUrl: 'assets/imgs/offer5.png',
    title: 'Televisions',
    subtitle: 'The Bambino Plus Coffee Machine',
    description:
      "Cafe quality coffee in a compact footprint. The Bambino Plus doesn't compromise on the 4 key elements of cafe quality coffee. Delivering barista-quality performance using a 54mm portafilter with 19 grams for full flavour and an automatic steam wand for milk texturing. With a 3 second heat up time and precise espresso extraction, you can go from bean to cup, faster than ever before. Just like your local cafe.",
    point_1: 2000,
    point_2: 112000,
    brandImageUrl: 'assets/imgs/quantas_reward.png',
    price: 634,
    url: '',
  },
  {
    id: 6,
    imgUrl: 'assets/imgs/offer2.png',
    title: 'Reedem your points with 10% discount shopwide',
    subtitle: 'The Bambino Plus Coffee Machine',
    description:
      "Cafe quality coffee in a compact footprint. The Bambino Plus doesn't compromise on the 4 key elements of cafe quality coffee. Delivering barista-quality performance using a 54mm portafilter with 19 grams for full flavour and an automatic steam wand for milk texturing. With a 3 second heat up time and precise espresso extraction, you can go from bean to cup, faster than ever before. Just like your local cafe.",
    point_1: 2000,
    point_2: 112000,
    brandImageUrl: 'assets/imgs/quantas_reward.png',
    price: 634,
    url: '',
  },
  {
    id: 7,
    imgUrl: 'assets/imgs/offer1.png',
    title: 'Save 0,15 per Litre at Caltex',
    subtitle: 'The Bambino Plus Coffee Machine',
    description:
      "Cafe quality coffee in a compact footprint. The Bambino Plus doesn't compromise on the 4 key elements of cafe quality coffee. Delivering barista-quality performance using a 54mm portafilter with 19 grams for full flavour and an automatic steam wand for milk texturing. With a 3 second heat up time and precise espresso extraction, you can go from bean to cup, faster than ever before. Just like your local cafe.",
    point_1: 2000,
    point_2: 112000,
    brandImageUrl: 'assets/imgs/quantas_reward.png',
    price: 634,
    url: '',
  },
  {
    id: 8,
    imgUrl: 'assets/imgs/offer2.png',
    title: 'Save 0,15 per Litre at Caltex',
    subtitle: 'The Bambino Plus Coffee Machine',
    description:
      "Cafe quality coffee in a compact footprint. The Bambino Plus doesn't compromise on the 4 key elements of cafe quality coffee. Delivering barista-quality performance using a 54mm portafilter with 19 grams for full flavour and an automatic steam wand for milk texturing. With a 3 second heat up time and precise espresso extraction, you can go from bean to cup, faster than ever before. Just like your local cafe.",
    point_1: 2000,
    point_2: 112000,
    brandImageUrl: 'assets/imgs/quantas_reward.png',
    price: 634,
    url: '',
  },
];
